import { createAction } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { call, put, takeLatest } from "redux-saga/effects";
import ApiService from "../../../services/ApiService";
import { setSuccess, startLogin } from "../../reducers/AuthReducer";

export const changePassAction = createAction("auth/changePassword");

function* changePassword({ payload }) {
  console.log("payload: ", payload);
  yield put(startLogin(null))
  try {
    let res = yield call(ApiService.changePassword, payload);
    console.log('changePass res: ', res.data);
    if(res.data.message === 'Successfully Password changed.') {
      toast.success(res.data.message);
      yield put(setSuccess(true))
    } else{
        toast.error(res.data.message);
        yield put(setSuccess(false))
    }
  } catch (error) {
    console.log({ error });
    toast.error(error);
    yield put(setSuccess(false))
  }
}
export function* changePassSaga() {
  yield takeLatest(changePassAction, changePassword)
}
